export default __webpack_public_path__ + "static/media/09.32.444bd19d.jpg";